
import React from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/MobileNavbar.css';

export default function MobileNavbar() {
  return (
    <footer className="mobile-navbar">
      <NavLink to="/" className={({ isActive }) => isActive ? "mobile-navbar-btn active" : "mobile-navbar-btn"}>
        <i className="bi bi-house"></i>
        <span>Home</span>
      </NavLink>

      <NavLink to="/solutions" className={({ isActive }) => isActive ? "mobile-navbar-btn active" : "mobile-navbar-btn"}>
        <i className="bi bi-tools"></i>
        <span>Solutions</span>
      </NavLink>

      <NavLink to="/about" className={({ isActive }) => isActive ? "mobile-navbar-btn active" : "mobile-navbar-btn"}>
        <i className="bi bi-info-circle"></i>
        <span>About</span>
      </NavLink>

      <NavLink to="/contact" className={({ isActive }) => isActive ? "mobile-navbar-btn active" : "mobile-navbar-btn"}>
        <i className="bi bi-envelope"></i>
        <span>Contact</span>
      </NavLink>

      <NavLink to="#"
              className={({ isActive }) => isActive ? "mobile-navbar-btn active whatsapp" : "mobile-navbar-btn whatsapp"}>
        
        
      </NavLink>
    </footer>
  );
}
